export const registerConnectStyles = () =>
	import(/* webpackChunkName: "async-jira-connect-css" */ './styles');
